import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ConfirmOpenTabDialogComponent,
  ConfirmOpenTabDialogData,
} from './confirm-open-tab-dialog.component';

/** Page bar Tablero tenant → shell POS en Tablero. */
export const POS_TABLERO_ENTRY_ROUTE = '/pos/tablero';

/** Ítem POS del rail tenant → shell POS en Venta. */
export const POS_VENTA_ENTRY_ROUTE = '/pos/venta';

export const ENTER_POS_TABLERO_DIALOG_DATA: ConfirmOpenTabDialogData = {
  titleKey: 'sales.board.openInPosTableroConfirmTitle',
  messageKey: 'sales.board.openInPosTableroConfirmMessage',
  confirmKey: 'sales.board.openInPosTableroConfirmAccept',
  cancelKey: 'sales.board.openInPosTableroConfirmCancel',
};

export const ENTER_POS_VENTA_DIALOG_DATA: ConfirmOpenTabDialogData = {
  titleKey: 'sales.board.openInPosVentaConfirmTitle',
  messageKey: 'sales.board.openInPosVentaConfirmMessage',
  confirmKey: 'sales.board.openInPosVentaConfirmAccept',
  cancelKey: 'sales.board.openInPosVentaConfirmCancel',
};

function openConfirm(
  dialog: MatDialog,
  data: ConfirmOpenTabDialogData
): Observable<boolean> {
  return dialog
    .open(ConfirmOpenTabDialogComponent, {
      width: '420px',
      maxWidth: '90vw',
      data,
    })
    .afterClosed()
    .pipe(map((confirmed) => confirmed === true));
}

/** Alerta page bar «Abrir en POS» (Tablero) → `/pos/tablero`. */
export function confirmEnterPosTablero(dialog: MatDialog): Observable<boolean> {
  return openConfirm(dialog, ENTER_POS_TABLERO_DIALOG_DATA);
}

/** Alerta ítem POS del rail tenant → `/pos/venta`. */
export function confirmEnterPosVenta(dialog: MatDialog): Observable<boolean> {
  return openConfirm(dialog, ENTER_POS_VENTA_DIALOG_DATA);
}

/** Abre el shell POS en otra pestaña (el admin actual no se reemplaza). */
export function openPosRouteInNewTab(route = POS_VENTA_ENTRY_ROUTE): void {
  const path = route.startsWith('/') ? route : `/${route}`;
  const absolute =
    path.startsWith('http://') || path.startsWith('https://')
      ? path
      : `${window.location.origin}${path}`;
  window.open(absolute, '_blank', 'noopener,noreferrer');
}

export function isPosShellEntryRoute(url: string): boolean {
  const path = url.split('?')[0];
  return path === '/pos' || path.startsWith('/pos/');
}
